document.addEventListener('DOMContentLoaded', function () {
    const mainProduct = document.getElementById('MainProduct');
    const mainBuyBtn = document.getElementById('MainBuyNow');
    const stickyContainer = document.getElementById('StickyBuyNow');
    const stickyBtn = stickyContainer ? stickyContainer.querySelector('.sticky-buy-now__btn') : null;

    // Guards
    if (!mainBuyBtn || !stickyContainer || !stickyBtn) return;

    // Click Handler: Delegate to main button
    stickyBtn.addEventListener('click', function () {
        mainBuyBtn.click();
    });

    // Intersection Observer
    const observerOptions = {
        root: null, // viewport
        threshold: 0
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            // Logic: If Main Btn is NOT intersecting (not visible) -> Show Sticky
            if (!entry.isIntersecting) {
                // Only show if we are effectively "below" the button (scrolled past it)
                // But for simplicity/robustness as requested: !intersecting -> show
                // We might want to check bounding client rect to ensure we haven't just scrolled UP past it (above fold).
                // Usually sticky appears when we scroll DOWN past the button.
                const rect = mainBuyBtn.getBoundingClientRect();
                if (rect.top < 0) {
                    stickyContainer.removeAttribute('hidden');
                } else {
                    stickyContainer.setAttribute('hidden', '');
                }
            } else {
                // Visible -> Hide Sticky
                stickyContainer.setAttribute('hidden', '');
            }
        });
    }, observerOptions);

    observer.observe(mainBuyBtn);
});
